import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';
import './Shared.css';

const Utilizatori = () => {
  const [users, setUsers] = useState([]);
  const [clase, setClase] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    nume: '',
    rol: 'educatoare',
    clasa: '',
    activ: true
  });

  useEffect(() => {
    loadUsers();
    loadClase();
  }, []);

  const loadUsers = async () => {
    try {
      const response = await axios.get('/api/admin/users');
      setUsers(response.data);
    } catch (error) {
      console.error('Eroare la încărcare utilizatori:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadClase = async () => {
    try {
      const response = await axios.get('/api/clase');
      setClase(response.data);
    } catch (error) {
      console.error('Eroare la încărcare clase:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = { ...formData };
      if (formData.rol === 'admin') {
        delete data.clasa;
      }
      if (editingUser && !data.password) {
        delete data.password;
      }

      if (editingUser) {
        await axios.put(`/api/admin/users/${editingUser._id}`, data);
      } else {
        await axios.post('/api/admin/users', data);
      }
      loadUsers();
      closeModal();
    } catch (error) {
      console.error('Eroare la salvare utilizator:', error);
      alert(error.response?.data?.message || 'Eroare la salvare utilizator');
    }
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setFormData({
      email: user.email,
      password: '',
      nume: user.nume,
      rol: user.rol,
      clasa: user.clasa?._id || '',
      activ: user.activ
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Sigur dorești să ștergi acest utilizator?')) {
      try {
        await axios.delete(`/api/admin/users/${id}`);
        loadUsers();
      } catch (error) {
        console.error('Eroare la ștergere utilizator:', error);
        alert('Eroare la ștergere utilizator');
      }
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingUser(null);
    setFormData({
      email: '',
      password: '',
      nume: '',
      rol: 'educatoare',
      clasa: '',
      activ: true
    });
  };

  if (loading) return <div>Se încarcă...</div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>Gestiune Utilizatori</h1>
          <p>Gestionează conturile de admin și educatoare</p>
        </div>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>
          + Adaugă Utilizator
        </button>
      </div>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Nume</th>
              <th>Email</th>
              <th>Rol</th>
              <th>Clasă</th>
              <th>Status</th>
              <th>Acțiuni</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user._id}>
                <td>{user.nume}</td>
                <td>{user.email}</td>
                <td>
                  <span className={`badge ${user.rol === 'admin' ? 'badge-warning' : 'badge-info'}`}>
                    {user.rol === 'admin' ? 'Admin' : 'Educatoare'}
                  </span>
                </td>
                <td>
                  {user.clasa ? `${user.clasa.numeGradinita} - ${user.clasa.numeClasa}` : '-'}
                </td>
                <td>
                  <span className={`badge ${user.activ ? 'badge-success' : 'badge-danger'}`}>
                    {user.activ ? 'Activ' : 'Inactiv'}
                  </span>
                </td>
                <td>
                  <button className="btn btn-secondary btn-sm" onClick={() => handleEdit(user)}>
                    Editează
                  </button>
                  <button className="btn btn-danger btn-sm" onClick={() => handleDelete(user._id)}>
                    Șterge
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingUser ? 'Editează Utilizator' : 'Adaugă Utilizator Nou'}</h2>
              <button className="modal-close" onClick={closeModal}>&times;</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nume *</label>
                <input
                  type="text"
                  value={formData.nume}
                  onChange={(e) => setFormData({ ...formData, nume: e.target.value })}
                  required
                  placeholder="ex: Maria Popescu"
                />
              </div>
              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  placeholder="exemplu@email.com"
                />
              </div>
              <div className="form-group">
                <label>Parolă {editingUser ? '(lasă gol pentru a nu schimba)' : '*'}</label>
                <input
                  type="password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  required={!editingUser}
                  placeholder="Minim 6 caractere"
                />
              </div>
              <div className="form-group">
                <label>Rol *</label>
                <select
                  value={formData.rol}
                  onChange={(e) => setFormData({ ...formData, rol: e.target.value })}
                  required
                >
                  <option value="educatoare">Educatoare</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
              {formData.rol === 'educatoare' && (
                <div className="form-group">
                  <label>Clasă *</label>
                  <select
                    value={formData.clasa}
                    onChange={(e) => setFormData({ ...formData, clasa: e.target.value })}
                    required
                  >
                    <option value="">Selectează clasa</option>
                    {clase.map(clasa => (
                      <option key={clasa._id} value={clasa._id}>
                        {clasa.numeGradinita} - {clasa.numeClasa}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.activ}
                    onChange={(e) => setFormData({ ...formData, activ: e.target.checked })}
                  />
                  {' '}Cont Activ
                </label>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Anulează
                </button>
                <button type="submit" className="btn btn-primary">
                  {editingUser ? 'Salvează' : 'Adaugă'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Utilizatori;
